import React, { useState } from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SmsRoundedIcon from '@mui/icons-material/SmsRounded';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import { darken } from '@mui/material/styles';
import ChatbotWidget from './ChatbotWidget';
import { startTour } from './OnboardingTour';
import { itemsListTourConfig, switcherConfiguratorTourConfig } from '../config/tourConfigs';

export default function SupportSpeedDial() {
  const [dialOpen, setDialOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  const handleChatToggle = () => {
    setChatOpen(prev => !prev);
    setDialOpen(false);
  };

  const handleFreshdeskOpen = () => {
    window.FreshworksWidget?.('open');
    setDialOpen(false);
  };

  const handleTourStart = () => {
    if (document.querySelector('#ItemsList')) {
      startTour(itemsListTourConfig);
    } else if (window.location.hash === '#switcher-configurator') {
      startTour(switcherConfiguratorTourConfig);
    } else {
      startTour();
    }
    setDialOpen(false);
  };

  return (
    <>
      <ChatbotWidget open={chatOpen} onToggle={handleChatToggle} />
      <SpeedDial
        ariaLabel="Support"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1001,
          '& .MuiSpeedDial-fab': {
            background: 'linear-gradient(135deg, #3a20cd, #9f2ccc)',
            '&:hover': {
              background: 'linear-gradient(135deg, #2a1790, #7a1a9a)',
            },
          },
        }}
        icon={<SpeedDialIcon icon={<HelpOutlineIcon />} openIcon={<CloseIcon />} />}
        open={dialOpen}
        onOpen={() => setDialOpen(true)}
        onClose={() => setDialOpen(false)}
      >
        <SpeedDialAction
          icon={<SmsRoundedIcon />}
          tooltipTitle="Chat"
          tooltipOpen
          onClick={handleChatToggle}
          FabProps={{
            sx: { bgcolor: 'accentMuted', color: '#fff', '&:hover': { bgcolor: (t) => darken(t.palette.accentMuted, 0.3) } },
          }}
          sx={{ '& .MuiSpeedDialAction-staticTooltipLabel': { bgcolor: '#1a1a2e', color: '#fff', whiteSpace: 'nowrap' } }}
        />
        <SpeedDialAction
          icon={<ContactSupportOutlinedIcon />}
          tooltipTitle="Support"
          tooltipOpen
          onClick={handleFreshdeskOpen}
          FabProps={{
            sx: { bgcolor: '#3a20cd', color: '#fff', '&:hover': { bgcolor: '#2a1790' } },
          }}
          sx={{ '& .MuiSpeedDialAction-staticTooltipLabel': { bgcolor: '#1a1a2e', color: '#fff', whiteSpace: 'nowrap' } }}
        />
        <SpeedDialAction
          icon={<MapOutlinedIcon />}
          tooltipTitle="Tour"
          tooltipOpen
          onClick={handleTourStart}
          FabProps={{
            sx: { bgcolor: '#9f2ccc', color: '#fff', '&:hover': { bgcolor: '#7a1a9a' } },
          }}
          sx={{ '& .MuiSpeedDialAction-staticTooltipLabel': { bgcolor: '#1a1a2e', color: '#fff', whiteSpace: 'nowrap' } }}
        />
      </SpeedDial>
    </>
  );
}
